<template>
  <div class="loader__wrapper" :class="wrapperCssClass">
    <div class="loader-dots__text">
      <slot name="text">Загрузка...</slot>
    </div>
    <div class="loader-dots">
      <div class="loader-dots__dot"></div>
      <div class="loader-dots__dot"></div>
      <div class="loader-dots__dot"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    wrapperCssClass: {
      type: String,
      default: ''
    }
  }
};
</script>
<style src="./loader.css" />
<style src="./loader-dots.css" />
